'use strict';

import TypeProperty from './TypeProperty';

/**
 * @property {string}         caption
 * @property {boolean}        compound
 * @property {boolean}        deprecated
 * @property {string}         deprecationNotice
 * @property {string}         description
 * @property {boolean}        entity
 * @property {boolean}        formattable
 * @property {boolean}        hidden
 * @property {string}         id
 * @property {boolean}        internal
 * @property {string}         minimumVersion
 * @property {string}         name
 * @property {boolean}        primitive
 * @property {TypeProperty[]} properties
 * @property {Api}            api
 */
class Type {
  /**
   * @param {string}         propName
   * @param {string}         name
   * @param {string}         caption
   * @param {boolean}        compound
   * @param {boolean}        deprecated
   * @param {string}         deprecationNotice
   * @param {string}         description
   * @param {boolean}        entity
   * @param {boolean}        formattable
   * @param {boolean}        hidden
   * @param {string}         id
   * @param {boolean}        internal
   * @param {string}         minimumVersion
   * @param {boolean}        primitive
   * @param {TypeProperty[]} properties
   * @param {Api}            api
   */
  constructor ( propName, {
    caption,
    compound,
    deprecated,
    deprecationNotice,
    description,
    entity,
    formattable,
    hidden,
    id,
    internal,
    minimumVersion,
    name,
    primitive,
    properties,
  }, api = null ) {
    this.name              = name;
    this.caption           = caption;
    this.compound          = compound;
    this.deprecated        = deprecated;
    this.deprecationNotice = deprecationNotice;
    this.description       = description;
    this.entity            = entity;
    this.formattable       = formattable;
    this.hidden            = hidden;
    this.id                = id;
    this.internal          = internal;
    this.minimumVersion    = minimumVersion;
    this.primitive         = primitive;
    this.properties        = Object.entries(properties).map(( [ name, property ] ) => new TypeProperty(name, property, this));
    this.api               = api;
  }

  /**
   * Returns the type string
   *
   * @returns {string}
   */
  toString () {
    return this.name;
  }

  stringifyValue ( value ) {
    if ( typeof value === 'string' && value.substring(0, 5) === 'json:' ) {
      return JSON.parse(value.substring(5));
    }

    switch ( this.name ) {
      case 'bool':
      case 'boolean':
        return Boolean(value);

      case 'int':
      case 'integer':
      case 'float':
        return Number(value);

      // eslint-disable-next-line
      case 'array':
        if ( !value ) {
          return [];
        }

        const values = Array.isArray(value)
                       ? value
                       : JSON.parse(value);

        return values.map(val => this.stringifyValue(val));

      case 'string':
      default:
        return String(value);
    }
  }
}

export default Type;
